module.exports = __webpack_public_path__ + "img/global-announcement.a1226d0a.jpg";